<template>  
  <v-container fluid grid-list-lg class="ma-0 pa-0">
    <v-card flat>
      <v-card-text>
        <v-layout row>
          <v-flex xs12 md12>
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.nomors"
              label="Berdasarkan Pertanyaan"
              :items="pertanyaans"
              item-text="name"        
              item-value="id"      
              multiple
              :loading="pertanyaanLoading"
              autocomplete="off"
            />
          </v-flex>          
        </v-layout> 
        <v-layout row>
          <v-flex xs6 md3 lg2 v-if="!disabled.addr_idkab">
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idpro"
              label="Provinsi"
              :items="provinsi"
              item-text="name"
              item-value="id"
              :loading="provinsiLoading"
              :disabled="disabled.addr_idpro"
              clearable
              autocomplete="off"
              multiple
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkab"
              label="Kabupaten/Kota"
              :items="kabupaten"
              item-text="name"
              item-value="id"
              :loading="kabupatenLoading"
              :disabled="disabled.addr_idkab"
              clearable autocomplete="off"
              multiple
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkec"
              label="Kecamatan"
              :items="kecamatan"
              item-text="name"
              item-value="id"
              :loading="kecamatanLoading"
              :disabled="disabled.addr_idkec"
              clearable autocomplete="off"
              multiple
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkel"
              label="Kelurahan"
              :items="kelurahan"
              item-text="name"
              item-value="id"
              :loading="kelurahanLoading"
              :disabled="disabled.addr_idkel"
              clearable autocomplete="off"
              multiple
            />
          </v-flex>  
          <!--<v-flex xs6 md3 lg2>                   
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.tps_id"
              label="TPS"
              :items="tps"
              item-text="name"
              item-value="id"
              :loading="tpsLoading"
              clearable autocomplete="off"
            />
          </v-flex>-->          
        </v-layout>       
      </v-card-text>
      <v-divider />
      <v-card-text>
        <v-layout row>
          <v-flex xs12 md6 v-for="(item, i) in charts" :key="i">
            <v-card>              
              <v-card-text class="px-2">{{item.no}}. {{item.question}}</v-card-text> 
              <v-divider/>          
              <v-card-text class="pa-0 text-center v-data-table__wrapper" style="overflow:auto" v-if="!item.loading" >
                <echart :option="item.chartOption" :height="item.height? item.height+'px':'390px'" style="min-width:300px" />              
                <v-expansion-panels accordion flat elevation="0">
                  <v-expansion-panel flat elevation="0">
                    <v-expansion-panel-header flat elevation="0" class="primary--text px-2">Cek Simulasi Sainte Lague</v-expansion-panel-header>
                    <v-divider/>
                    <v-expansion-panel-content class="text-left">
                      <sainte-lague :question.sync="item" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>                
              </v-card-text>              
              <template v-else>
                <v-skeleton-loader                
                  style="width:100%"
                  type="card, article"
                ></v-skeleton-loader>
              </template>
            </v-card>               
          </v-flex>          
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Echart from '@/app/components/other/echart';
import { debounce } from 'lodash'
import Model from '@/app/models/Report'
import SainteLague from './sainte-lague.vue';
const  model = new Model()

export default {
  components:{Echart,SainteLague},
  props:{
    jilid : {type:Object},    
  },
  data () {
    return {
      fm:{ nomor:1, nomors:[], addr_idpro:[], addr_idkab: [], addr_idkec:[], addr_idkel:[] },    
      disabled : {addr_idpro : false, addr_idkab: false, addr_idkec: false, addr_idkel:false},
      provinsi  : [], kabupaten : [], kecamatan : [], kelurahan : [], tps:[],
      provinsiLoading  : false, kabupatenLoading : false, kecamatanLoading : false, kelurahanLoading : false, tpsLoading:false,
      

      charts : [],
      pertanyaans  : [], pertanyaanLoading  : false, 
      loading : false,
      demografi: [],
      chartOption :  {
        title: {
            text: 'Efektifitas (%)',
            subtext: 'Sebaran Responden'
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: "{b} : {c}%"    
        },
        legend: {
            data: ['responden']
        },
        toolbox: {
            show : true,
            x: 'right',
            feature : {
                mark : {show: true},
                //dataView : {show: true, readOnly: false},
                //restore : {show: true},
                saveAsImage : {show: true, title:'Pict'}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
        },
        yAxis: {
            type: 'category',
            data: ['巴西','印尼','美国','印度','中国','世界人口(万)']
        },
        series: [
            {
                name: 'responden',
                type: 'bar',
                label: {
                  normal: {
                    show: true,
                    position: 'right',
                    formatter: "{c}%"    
                  },                  
                },
                data: [18203, 23489, 29034, 104970, 131744, 630230]
            },  
        ]
      },
    }
  },
  computed:{
        
  },
  watch:{
    'fm.nomors'(newIds) {
      if(Array.isArray(this.jilid.quetionnaires)){
        this.charts = [];
        newIds.forEach(id=>{        
          let q = this.jilid.quetionnaires.find(x=>x.no==id);
          if(q){
            this.charts.push({no:q.no, type:q.type, question:q.question, loading:true, option:q.option, chartOption:{}, height:390, kuota:Array.isArray(q.option)?q.option.length : 3, persen_pmlih: 65});        
          }          
        })
      }            
    },
    'fm': {
      handler : debounce(function () {      
        this.readItems()
      }, 2500), 
      deep:true,
    },
    'fm.addr_idpro':debounce(function (newId,oldId) {
      if(newId && newId[0]){
        newId = newId[0]      
        if(!this.provinsi.length)model.node({id:newId,jilid_id:this.jilid.id}).then(res=>{this.provinsi.push(res)});
        this.kabupatenLoading = true; //this.fm.addr_idkab = null;
        model.kabupaten({parent:newId,jilid_id:this.jilid.id}).then(data=>{
          this.kabupaten=data; this.kabupatenLoading = false;  
          this.fm.addr_idkab = this.fm.addr_idkab && data.find(x=>x.id === this.fm.addr_idkab) ? this.fm.addr_idkab : null;         
        })
      } else {
        this.fm.addr_idkab = null; this.kabupaten = []; 
        this.fm.addr_idkec = null; this.kecamatan = []; 
        this.fm.addr_idkel = null; this.kelurahan = []; 
      }
    }, 2000),     
    'fm.addr_idkab':debounce(function (newId) {
      if(newId && newId[0]){
        newId = newId[0]
        if(!this.kabupaten.length)model.node({id:newId,jilid_id:this.jilid.id}).then(res=>{this.kabupaten.push(res)});          
        this.kecamatanLoading = true;
        model.kecamatan({parent:newId,jilid_id:this.jilid.id}).then(data=>{
          this.kecamatan=data; this.kecamatanLoading = false;
          this.fm.addr_idkec = this.fm.addr_idkec && data.find(x=>x.id===this.fm.addr_idkec) ? this.fm.addr_idkec:null;
          if(this.kecamatan.find(x=>x.id===this.fm.addr_idkec)){
            this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode:this.kecamatan.find(x=>x.id===this.fm.addr_idkec).kodepos;
          }  
        })
        //model.node({id:newId,jilid_id:this.jilid.id}).then(data=>{this.fm.addr_idpro = [data.parent_id];})
      } else {
        this.fm.addr_idkec = null; this.kecamatan = []; 
        this.fm.addr_idkel = null; this.kelurahan = [];         
      }      
    }, 2000),            
    'fm.addr_idkec':debounce(function (newId) {
      if(newId && newId[0]){      
        newId = newId[0]        
        if(!this.kecamatan.length)model.node({id:newId,jilid_id:this.jilid.id}).then(res=>{this.kecamatan.push(res)});                  
        this.kelurahanLoading = true; 
        model.kelurahan({parent:newId,jilid_id:this.jilid.id}).then(data=>{
          this.kelurahan=data; this.kelurahanLoading = false;
          this.fm.addr_idkel = this.fm.addr_idkel && data.find(x=>x.id===this.fm.addr_idkel) ? this.fm.addr_idkel : null;           
        })      
        if(this.kecamatan.find(x=>x.id===newId)){
          let kodepos = this.kecamatan.find(x=>x.id===newId).kodepos;
          this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode : kodepos; 
        }  
      } else {
        this.fm.addr_idkel = null; this.kelurahan = [];
      }
    }, 2000),  
    'fm.addr_idkel':debounce(function (newId) {      
      if(newId && newId[0]){
        newId = newId[0]
        if(newId){        
          this.tpsLoading = true;
          model.node({id:newId,jilid_id:this.jilid.id}).then(data=>{
            this.kelurahan.push(data); 
            model.tps({idkel:data.id}).then(res=>{
              this.tps = res.data;
              this.tpsLoading = false;
            })
          })  
        } else if(this.kelurahan.find(x=>x.id===newId)){      
          this.tpsLoading = true;
          model.tps({idkel:newId}).then(res=>{
            this.tps = res.data;
            this.tpsLoading = false;
          })
        }
      }
    }, 2000),   
    'jilid.id'(){
      this.init()
    }
  },  
  mounted() {
    this.loading = true;
    this.init();
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    init(){      
      if(this.jilid.node_id){
        model.node({id:this.jilid.node_id,jilid_id:this.jilid.id}).then(res=>{
          if(res.level){
            this.disabled.addr_idpro = false;
            this.disabled.addr_idkab = false;
            this.disabled.addr_idkec = false;
            this.disabled.addr_idkel = false;
            /*this.fm.addr_idpro = [];
            this.fm.addr_idkab = [];
            this.fm.addr_idkec = [];
            this.fm.addr_idkel = [];*/
            switch(parseInt(res.level)){
              case 1: this.fm.addr_idpro = [res.id];
                this.disabled.addr_idpro = true;
                break;
              case 2: this.fm.addr_idkab = [res.id]; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                break;
              case 3: this.fm.addr_idkec = [res.id]; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                this.disabled.addr_idkec = true;
                break;
              case 4: this.fm.addr_idkel = [res.id]; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                this.disabled.addr_idkec = true;
                this.disabled.addr_idkel = true;
                break;
              
            }            
          }            
        })
      }
      if(Array.isArray(this.jilid.quetionnaires)){
        let no = 0;
        this.jilid.quetionnaires.forEach(q=>{
          this.pertanyaans.push({id:q.no, name:q.no+'. '+q.question, loading:true,option:{}});
          if(q.type == 1 && no <4 && (q.no > 9 || q.question.toLowerCase().includes('pilih'))){
            this.fm.nomors.push(q.no);
            no++;
          }                              
        })
      }
    },

    readItems () {
      if(Array.isArray(this.charts)){
        this.charts.forEach(c=>{
          c.loading = true;    
          const params = {        
            jilid_id: this.jilid.id,        
            no: c.no,
            type: c.type,
            expand:'quetionnaires',
            idpro:this.fm.addr_idpro,
            idkab:this.fm.addr_idkab,
            idkec:this.fm.addr_idkec,
            idkel:this.fm.addr_idkel
          }


          model.demografi(params).then(data => {   
            if(Array.isArray(data) && Array.isArray(c.option)){
              c.demografi = data;
              c.height = data.length*45 > 390 ? data.length*45 : 390;
              c.chartOption = JSON.parse(JSON.stringify(this.chartOption));
              c.chartOption.yAxis.data = [];
              c.chartOption.series[0].data = []; 
              //c.chartOption.title.subtext = c.no+'. '+c.question;             
              let color = this.$color();              
              c.chartOption.series[0].itemStyle = {color:color};
              let total = 0;              
              for(var i in data){
                total += parseInt(data[i].people)
              }
              //data.forEach(item=>{total += parseInt(item.people);}); 
              c.option.reverse();             
              c.option.forEach(opt =>{
                let item = data.find(x=>x.answer==opt.id)
                if(c.type == 3){
                    c.chartOption.yAxis.data.push(item.answer+"\n["+item.people+"]");
                    c.chartOption.series[0].data.push(parseFloat(parseInt(item.people)/total*100).toFixed(2));                  
                } else {
                  if(item){
                    c.chartOption.yAxis.data.push(opt.value+"\n["+item.people+"]");
                    c.chartOption.series[0].data.push(parseFloat(parseInt(item.people)/total*100).toFixed(2));                                    
                  }                  
                }
              })
              /*data.forEach(item=>{    
                if(c.type == 3){
                    c.chartOption.yAxis.data.push(item.answer+"\n["+item.people+"]");
                    c.chartOption.series[0].data.push(parseFloat(parseInt(item.people)/total*100).toFixed(2));                  
                } else {
                  if(c.type == 2){
                    //total = this.jilid.counting.all;
                  }
                  let opt = c.option.find(x=>x.id==item.answer);
                  if(opt){
                    c.chartOption.yAxis.data.push(opt.value+"\n["+item.people+"]");
                    c.chartOption.series[0].data.push(parseFloat(parseInt(item.people)/total*100).toFixed(2));                  
                  } else {
                    c.chartOption.yAxis.data.push("-"+"\n["+item.people+"]");
                    c.chartOption.series[0].data.push(parseFloat(parseInt(item.people)/total*100).toFixed(2));
                  }
                }                       
              });*/
            }
            c.loading = false
          })
        })
      }            
    },      
  },  
}
</script>
<style>
.v-expansion-panel-content__wrap{
  padding: 10px!important;  
}
</style>